// ABOUTME: React hook for the storefront's GDPR consent record (localStorage-backed).
// ABOUTME: Exposes consent, needsDecision, hasAudioConsent, and a versioned saveConsent.

import { useCallback, useState } from 'react';
import { CONSENT_STORAGE_KEY, CONSENT_VERSION, canCaptureAudio } from './consentConfig';

// Read + validate the stored record. Returns the record only if it is well-formed and
// matches the current policy version; otherwise null (→ re-prompt). Never throws.
const readConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.v !== CONSENT_VERSION || !parsed.categories) return null;
    return parsed;
  } catch {
    return null;
  }
};

export function useConsent() {
  // Lazy init mirrors the wishlist persistence idiom in App.js (read localStorage once).
  const [consent, setConsent] = useState(readConsent);

  const saveConsent = useCallback((categories) => {
    const record = { v: CONSENT_VERSION, ts: Date.now(), categories };
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
    } catch {
      // Storage full / disabled: keep the choice in memory for this session.
    }
    setConsent(record);
  }, []);

  return {
    consent,
    needsDecision: consent === null,
    hasAudioConsent: canCaptureAudio(consent),
    saveConsent,
  };
}
